import * as React from "react";

import { Box, Grid } from "@material-ui/core";

import RoleandBranchInput from "../components/RoleandBranchInput";
import BranchesSelect from "../components/BranchesSelect";
import StatusInput from "../components/StatusInput";
import RightGridCreate from "../components/RightGridCreate";
import LayoutContainer from "../components/LayoutContainer";
import TextInputRA from "../components/TextInputRA";
import LeftGridCreate from "../components/LeftGridCreate";
import UserValidation from "../../../ValidationRules/UserValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
/*
{
  "locale": "en-US",
  "type": "Product",
  "name": "Ear Pod",
  "desc": "description",
  "base_price": 1000,
  "retail_price": 10000,
  "currency": "THB",
  "unit": "Piece",
  "hashtags[]": [
    "#iphone"
  ],
    "status": "Active",
  "sub_category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "category_id": "xxxxxx-5902ca0b0257bb14df426921",
  "realm_id": "xxxxxx-5902ca0b0257bb14df426921",
  "branch_id": "xxxxxx-5902ca0b0257bb14df426921",
  "action": "upload_image"
*/
const transform = (data) => {
  if (!data.branchSelected)
    return {
      ...data,
      roles: [
        {
          scope: {
            branch_id: data.branches.map((branch) => branch.id),
          },
          role_id: data.role_id,
        },
      ],
    };
  return {
    ...data,
    roles: [
      {
        scope: {
          branch_id: data.branchSelected,
        },
        role_id: data.role_id,
      },
    ],
  };
};
const UserCreate = (props) => (
  <LayoutContainer>
    <Grid container style={{ height: "100%" }}>
      <LeftGridCreate
        {...props}
        transform={transform}
        validate={UserValidation}
      >
        <SfBreadcrumbs path="Management/Users" />
        <Box style={{margin:" 30px 50px 50px" }}>
          <TextInputRA required label="Username" source="username" />
          <TextInputRA
            required
            source="employee_no"
            label="Employee number"
            format={(input) => String(input ?? "")}
            parse={(input) => String(input ?? "")}
          />
          <TextInputRA required source="firstname" label="Firstname" />
          <TextInputRA required source="lastname" label="Lastname" />
          <TextInputRA label="Birthdate" source="birthdate" type="date" />
          <TextInputRA required label="Phone" source="phone" type="phone" />
          <TextInputRA required label="Email" source="email" />
          <RoleandBranchInput required />
          <BranchesSelect noCurrent required />

          <StatusInput />
        </Box>
      </LeftGridCreate>
      <RightGridCreate />
    </Grid>
    {/* <Create {...props} title="Create user">
      <SimpleForm>
        <HiddenInputRA source="locale" initialValue="th-TH" />
        <HiddenInputRA source="status" initialValue="Active" />
        <TextInputRA label="Username" source="username" />
        <TextInputRA
          source="employee_no"
          label="Employee number"
          format={(input) => String(input ?? "")}
          parse={(input) => String(input ?? "")}
        />
        <TextInputRA label="Firstname" source="firstname" />
        <TextInputRA label="Lastname" source="lastname" />
        <TextInputRA label="Phone" source="phone" type="phone" />
        <TextInputRA label="Email" source="email" />

        <ArrayInput source="roles">
          <SimpleFormIterator>
            <ReferenceArrayInput
              label="Role"
              source="role_id"
              reference="merchant-roles"
            >
              <SelectInputRA optionText="name" />
            </ReferenceArrayInput>
            <ArrayInput source="scope.branch_id" label="Select branches">
              <SimpleFormIterator>
                <ReferenceArrayInput
                  label="ฺBranch"
                  source=""
                  reference="merchant-branches"
                >
                  <SelectInputRA optionText="name" />
                </ReferenceArrayInput>
              </SimpleFormIterator>
            </ArrayInput>
          </SimpleFormIterator>
        </ArrayInput>

        <ImageInput source="image" label="Picture" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create> */}
    <PermissionChecker code="Page.Merchant.Management.User" write />
  </LayoutContainer>
);

export default UserCreate;
